// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configuration_modal_container__Phnys {
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 12px;
}

.configuration_modal_header__-c5XO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #b1b1b1;
  font-size: 12px;
  font-family: "Poppins", sans-serif;
  -webkit-user-select: none;
          user-select: none;
}

.configuration_modal_header__-c5XO input[type="text"] {
  border-radius: 8px;
  background-color: #f6f6f6;
  color: #8b8b8b;
  outline: none;
  border: none;
  font-size: 16px;
  padding: 4px 6px;
  max-width: 150px;
}

.configuration_modal_body__1epTR {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 24px 50px 0 50px;
}

.configuration_modal_outputContainer__uz4Cv {
  flex-basis: 18%;
}

.configuration_modal_outputToggle__xPHbz {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #f6f6f6;
  color: #8b8b8b;
  height: 30px;
  max-width: 60px;
  font-size: 14px;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  margin-bottom: 12px;
}

.configuration_modal_active__kTcbn {
  background-color: #375395 !important;
  color: #ffffff !important;
}

.configuration_modal_addButton__\\+mAvJ {
  background-color: #f6a0a6;
  color: #ffffff;
  font-size: 14px;
  border-radius: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
  height: 32px;
  padding: 0 10px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.configuration_modal_select-container__5cOpv {
  position: relative;
}

.configuration_modal_select-container__5cOpv select {
  z-index: 1000000000;
}

.configuration_modal_select-container__5cOpv .configuration_modal_select-options__yPE19 {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2000000000000;
}
`, "",{"version":3,"sources":["webpack://./src/screens/dashboard/modals/configuration/configuration_modal.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;AACxB","sourcesContent":[".container {\n  border: 1px solid #e4e4e4;\n  border-radius: 6px;\n  padding: 10px 14px;\n  margin-bottom: 12px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #b1b1b1;\n  font-size: 12px;\n  font-family: \"Poppins\", sans-serif;\n  user-select: none;\n}\n\n.header input[type=\"text\"] {\n  border-radius: 8px;\n  background-color: #f6f6f6;\n  color: #8b8b8b;\n  outline: none;\n  border: none;\n  font-size: 16px;\n  padding: 4px 6px;\n  max-width: 150px;\n}\n\n.body {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 24px 50px 0 50px;\n}\n\n.outputContainer {\n  flex-basis: 18%;\n}\n\n.outputToggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  background-color: #f6f6f6;\n  color: #8b8b8b;\n  height: 30px;\n  max-width: 60px;\n  font-size: 14px;\n  font-weight: 500;\n  user-select: none;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.active {\n  background-color: #375395 !important;\n  color: #ffffff !important;\n}\n\n.addButton {\n  background-color: #f6a0a6;\n  color: #ffffff;\n  font-size: 14px;\n  border-radius: 7px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100px;\n  height: 32px;\n  padding: 0 10px;\n  user-select: none;\n  cursor: pointer;\n}\n\n.select-container {\n  position: relative;\n}\n\n.select-container select {\n  z-index: 1000000000;\n}\n\n.select-container .select-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 2000000000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `configuration_modal_container__Phnys`,
	"header": `configuration_modal_header__-c5XO`,
	"body": `configuration_modal_body__1epTR`,
	"outputContainer": `configuration_modal_outputContainer__uz4Cv`,
	"outputToggle": `configuration_modal_outputToggle__xPHbz`,
	"active": `configuration_modal_active__kTcbn`,
	"addButton": `configuration_modal_addButton__+mAvJ`,
	"select-container": `configuration_modal_select-container__5cOpv`,
	"select-options": `configuration_modal_select-options__yPE19`
};
export default ___CSS_LOADER_EXPORT___;
